import type { App as AntApp } from 'antd';
import { signOutUser } from '../auth/index.js';
import { plural } from '../options/format.js';

type Modal = ReturnType<typeof AntApp.useApp>['modal'];

/**
 * Signs the learner out. Changes that could not be sent to their account first (no connection)
 * would be lost with the sign-out, so they are told how many there are and can stay signed in.
 * Returns false when they chose to stay.
 */
export async function confirmAndSignOut(modal: Modal): Promise<boolean> {
  const first = await signOutUser();
  if (first.signedOut) return true;

  const some = plural(first.unsent, 'change');
  const goAhead = await new Promise<boolean>((resolve) => {
    modal.confirm({
      title: `${some} not saved to your account yet`,
      content: `LingoPing couldn't reach the server. If you sign out now, ${
        first.unsent === 1 ? 'this change is' : 'these changes are'
      } lost.`,
      okText: 'Sign out anyway',
      okButtonProps: { danger: true },
      cancelText: 'Stay signed in',
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
  if (!goAhead) return false;
  await signOutUser({ discardUnsent: true });
  return true;
}
